/**
 * Tenant courant : vit dans l'URL (`/$tenant/...`), jamais passé à la main aux appels API.
 * Le mutator lit cette valeur et pose l'en-tête `X-Tenant` sur chaque requête (P8 : le
 * transformer orval retire `X-Tenant` des ~337 opérations du contrat qui le déclarent).
 */
let currentTenant = '';

export function setCurrentTenant(tenant: string): void {
  currentTenant = tenant;
}

export function getCurrentTenant(): string {
  return currentTenant;
}

/** Jeton d'accès OIDC courant (posé par authService en J2, jamais persisté ici). */
let accessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}
